import { render } from "./ExplanationComponent.vue?vue&type=template&id=343057ea&scoped=true"
import script from "./ExplanationComponent.vue?vue&type=script&lang=js"
export * from "./ExplanationComponent.vue?vue&type=script&lang=js"

import "./ExplanationComponent.vue?vue&type=style&index=0&id=343057ea&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343057ea"]])

export default __exports__